import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaFire, FaStar, FaClipboardList, FaUsers } from 'react-icons/fa';
import { networkApi } from '../../api/networkApi';
import { userApi } from '../../api/userApi';
import appConfig from '../../utils/appConfig';
import '../../css/consolidated-sidebar.css';

export const ConsolidatedSidebar = () => {
  const navigate = useNavigate();
  const [hotNetworks, setHotNetworks] = useState([]);
  const [favoriteNetworks, setFavoriteNetworks] = useState([]);
  const [recentNetworks, setRecentNetworks] = useState([]);
  const [recentUsers, setRecentUsers] = useState([]);

  useEffect(() => {
    // Skip loading data if in single network mode
    if (appConfig.isSingleNetworkMode()) {
      return;
    }

    networkApi.getHotNetworks().then(data => setHotNetworks(data.slice(0, 5))).catch(console.error);
    networkApi.getFavoriteNetworks().then(data => setFavoriteNetworks(data.slice(0, 5))).catch(console.error);
    networkApi.getRecentNetworks(5).then(data => setRecentNetworks(data)).catch(console.error);
    userApi.getRecentUsers(5).then(data => setRecentUsers(data)).catch(console.error);
  }, []);

  const NetworkItem = ({ network }) => {
    const handleClick = () => {
      // Always prefer /n/{subDomain} format if subDomain is available
      if (network.subDomain) {
        const urlSafeSubDomain = network.subDomain.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]/g, '');
        navigate('/n/' + urlSafeSubDomain);
      } else {
        navigate('/network/' + network.businessNetworkID);
      }
    };

    return (
      <div
        className="d-flex align-items-center mb-2 p-2 rounded hover-bg consolidated-sidebar-network-item"
        onClick={handleClick}
      >
        <img
          src={network.logoUrl || '/logo/image.png'}
          alt={network.name}
          className="consolidated-sidebar-network-logo"
          onError={(e) => { e.target.src = '/logo/image.png'; }}
        />
        <small className="text-truncate">{network.name}</small>
      </div>
    );
  };

  const UserItem = ({ user }) => (
    <div
      className="mb-2 p-2 rounded hover-bg consolidated-sidebar-user-item"
      onClick={() => navigate('/user/' + user.createdByWalletUserRegistrationID)}
    >
      <div className="fw-bold small">{user.firstName || 'Anonymous'}</div>
      <small className="text-muted text-truncate d-block">{user.rootIdentityUrl}</small>
    </div>
  );

  // Don't render sidebar in single network mode
  if (appConfig.isSingleNetworkMode()) {
    return null;
  }

  return (
    <div className="sidebar">
      <div className="sidebar-section mb-4">
        <h6><FaFire className="me-2 consolidated-sidebar-icon-hot" />Hot Networks</h6>
        {hotNetworks.length > 0 ? (
          hotNetworks.map(network => <NetworkItem key={network.businessNetworkID} network={network} />)
        ) : (
          <p className="text-muted small">No hot networks</p>
        )}
      </div>

      <div className="sidebar-section mb-4">
        <h6><FaStar className="me-2 consolidated-sidebar-icon-favorite" />Favorite Networks</h6>
        {favoriteNetworks.length > 0 ? (
          favoriteNetworks.map(network => <NetworkItem key={network.businessNetworkID} network={network} />)
        ) : (
          <p className="text-muted small">No favorite networks</p>
        )}
      </div>

      <div className="sidebar-section mb-4">
        <h6><FaClipboardList className="me-2 consolidated-sidebar-icon-recent" />Recent Networks</h6>
        {recentNetworks.length > 0 ? (
          recentNetworks.map(network => <NetworkItem key={network.businessNetworkID} network={network} />)
        ) : (
          <p className="text-muted small">No recent networks</p>
        )}
      </div>

      <div className="sidebar-section">
        <h6><FaUsers className="me-2 consolidated-sidebar-icon-users" />Recent Users</h6>
        {recentUsers.length > 0 ? (
          recentUsers.map(user => <UserItem key={user.createdByWalletUserRegistrationID} user={user} />)
        ) : (
          <p className="text-muted small">No recent users</p>
        )}
      </div>
    </div>
  );
};
